import POption from '../p-select/src/option';

/* istanbul ignore next */
POption.install = function(Vue) {
  Vue.component(POption.name, POption);
};

export default POption;
